(() => {
  if (!customElements.get('ps-library')) customElements.define('ps-library', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.lifecycle = new AbortController(); const {signal} = this.lifecycle;
      const search = this.querySelector('input[type="search"]');
      const filters = [...this.querySelectorAll('[data-topic]')];
      const cards = [...this.querySelectorAll('[data-guide-card]')];
      const status = this.querySelector('[data-guide-count]');
      const clear = this.querySelector('[data-guide-clear]');
      const empty = this.querySelector('[data-guide-empty]');
      let topic = 'all';
      const norm = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const update = (writeUrl = true) => {
        const query = norm(search.value.trim()); let count = 0;
        for (const card of cards) {
          const matches = (topic === 'all' || card.dataset.category === topic) && query.split(/\s+/).every(word => norm(card.dataset.search || card.textContent).includes(word));
          card.hidden = !matches; if (matches) count++;
        }
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === topic)));
        status.textContent = `${count} ${count === 1 ? 'guide' : 'guides'}`;
        empty.hidden = count !== 0; clear.hidden = !query && topic === 'all';
        if (writeUrl) {
          const url = new URL(location.href);
          topic === 'all' ? url.searchParams.delete('topic') : url.searchParams.set('topic', topic);
          search.value.trim() ? url.searchParams.set('q', search.value.trim()) : url.searchParams.delete('q');
          history.replaceState(history.state, '', url);
        }
      };
      const restore = () => {
        const params = new URLSearchParams(location.search);
        topic = filters.some(b => b.dataset.topic === params.get('topic')) ? params.get('topic') : 'all';
        search.value = params.get('q') || ''; update(false);
      };
      filters.forEach(button => button.addEventListener('click', () => {topic = button.dataset.topic; update();}, {signal}));
      search.addEventListener('input', () => update(), {signal});
      clear.addEventListener('click', () => {topic = 'all'; search.value = ''; update(); search.focus();}, {signal});
      this.addEventListener('submit', event => {event.preventDefault(); update();}, {signal});
      window.addEventListener('popstate', restore, {signal}); restore();
      const photoButton = this.querySelector('[data-edu-notes]');
      if (photoButton) photoButton.addEventListener('click', () => {
        const open = photoButton.getAttribute('aria-pressed') !== 'true';
        photoButton.setAttribute('aria-pressed', String(open));
        photoButton.closest('.ps-learn-feature__art').dataset.notes = String(open);
        photoButton.textContent = open ? 'Show clean bottle' : 'See the scent notes';
      }, {signal});
    }
    disconnectedCallback() {this.lifecycle?.abort(); this.ready=false;}
  });
  if (!customElements.get('ps-guide')) customElements.define('ps-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.lifecycle = new AbortController(); const {signal} = this.lifecycle;
      const toc = this.querySelector('.ps-guide-toc details');
      if (toc) toc.open = matchMedia('(min-width:1000px)').matches;
      const body = this.querySelector('.ps-guide-body');
      const links = [...this.querySelectorAll('.ps-guide-toc a')];
      links.forEach(link => link.addEventListener('click', () => history.replaceState(history.state, '', link.href), {signal}));
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 90;
        const rect = body.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (header - rect.top) / Math.max(1, rect.height - innerHeight + header)));
        this.style.setProperty('--read-progress', progress);
        let current = links[0];
        for (const link of links) {const section = document.getElementById(link.hash.slice(1)); if (section && section.getBoundingClientRect().top <= header + 150) current = link;}
        links.forEach(link => link === current ? link.setAttribute('aria-current','true') : link.removeAttribute('aria-current'));
      };
      this.onScroll = () => {if (!scheduled) {scheduled = true; this.frame = requestAnimationFrame(update);}};
      addEventListener('scroll', this.onScroll, {passive:true, signal}); update();
    }
    disconnectedCallback() {this.lifecycle?.abort(); cancelAnimationFrame(this.frame); this.ready=false;}
  });
})();
